import IAction from "../store/IAction";
import InitState from "../store/initState";
import IErrorCaseVm from "../models/issuingAuthority/IErrorCaseVm";
import { Dispatch } from "redux";
import * as metaReducer from "./metaReducer";
import IErrorCaseSearchVm from "../models/issuingAuthority/IErrorCaseSearchVm";
import Api from "../services/api";
import { ErrorCaseStatusType } from "../models/enums/ErrorCaseStatusType";
import IErrorVm from "../models/home/Error/IErrorVm";
import { IErrorCaseSearchObject, ISortObject } from "./metaReducer";

const REPLACE_ERROR_CASES = "BAT2/errorCase/REPLACE_ERROR_CASES";
const REPLACE_ERROR_CASE = "BAT2/errorCase/REPLACE_ERROR_CASE";
const UPDATE_COMMENT = "BAT2/errorCase/UPDATE_COMMENT";
const UPDATE_ERROR_CASE_STATUS = "BAT2/errorCase/UPDATE_ERROR_CASE_STATUS";

export default function errorCasesReducer(state: IErrorCaseVm[] = new InitState().errorCases, action: IAction): IErrorCaseVm[] {
  switch (action.type) {
    case REPLACE_ERROR_CASE:
      return [...state].map((errorCase) => {
        if (errorCase.id !== (action.payload as IErrorCaseVm).id) {
          return errorCase;
        }
        return {
          ...errorCase,
          ...action.payload,
        };
      });
    case REPLACE_ERROR_CASES:
      return [...action.payload];
    default:
      if (state.length) {
        return [...state].map((errorCase: IErrorCaseVm) => {
          return errorCaseReducer(errorCase, action);
        });
      }
  }
  return state;
}

function errorCaseReducer(state: IErrorCaseVm = new InitState().errorCase, action: IAction): IErrorCaseVm {
  if (state === null || state === undefined) {
    return state;
  }

  if (state.id === action.id) {
    switch (action.type) {
      case UPDATE_COMMENT:
        return { ...state, comment: action.payload };
      case UPDATE_ERROR_CASE_STATUS:
        return { ...state, errorCaseStatus: action.payload };
      default:
        return state;
    }
  } else {
    return state;
  }
}

// When Search button is pressed
export function updateErrorCaseSearchListAndSearch(errorCaseSearchObject: IErrorCaseSearchObject) {
  return async (dispatch: Dispatch<any>, getState: () => InitState) => {
    const errorCaseSearchListPageNumber = getState().meta.errorCaseSearchListPageNumber;
    const errorCaseSearchSort = getState().meta.errorCaseSearchSort;

    dispatch(metaReducer.updateErrorCaseSearchObject(errorCaseSearchObject));
    dispatch(searchErrors(errorCaseSearchObject, errorCaseSearchSort, errorCaseSearchListPageNumber));
  };
}

// When change page is pressed
export function updateErrorCaseSearchPageNumberAndSearch(errorCaseSearchListPageNumber: number) {
  return async (dispatch: Dispatch<any>, getState: () => InitState) => {
    const errorCaseSearchObject = getState().meta.errorCaseSearchObject;
    const errorCaseSearchSort = getState().meta.errorCaseSearchSort;

    dispatch(metaReducer.updateErrorCaseListPage(errorCaseSearchListPageNumber));
    dispatch(searchErrors(errorCaseSearchObject, errorCaseSearchSort, errorCaseSearchListPageNumber));
  };
}

// When header (sort) is pressed
export function updateErrorCaseListSortAndSearch(errorCaseSearchSort: ISortObject) {
  return async (dispatch: Dispatch<any>, getState: () => InitState) => {
    const errorCaseSearchObject = getState().meta.errorCaseSearchObject;
    const errorCaseSearchListPageNumber = getState().meta.errorCaseSearchListPageNumber;

    dispatch(metaReducer.updateErrorCaseListSort(errorCaseSearchSort));
    dispatch(searchErrors(errorCaseSearchObject, errorCaseSearchSort, errorCaseSearchListPageNumber));
  };
}

function searchErrors(errorCaseSearchObject: IErrorCaseSearchObject, errorCaseSearchSort: ISortObject, errorCaseSearchListPageNumber: number) {
  return async (dispatch: Dispatch<any>) => {
    const errorCaseSearchResult: IErrorCaseSearchVm = await Api.errorCase.searchErrorCases(errorCaseSearchSort.sortPropertyName, errorCaseSearchSort.sortOrderASC, errorCaseSearchListPageNumber, errorCaseSearchObject);

    dispatch({ type: REPLACE_ERROR_CASES, payload: errorCaseSearchResult.errorCaseList });
    dispatch(metaReducer.updateErrorCaseSearchTotalRowsCount(errorCaseSearchResult.count));
  };
}

export function takeErrorCase(errorCase: IErrorCaseVm) {
  return async (dispatch: Dispatch<any>) => {
    let res: IErrorCaseVm | IErrorVm = null;
    res = await Api.errorCase.takeErrorCase(errorCase.id);

    if (!!res && !!res.errorNumber) {
      dispatch({ type: REPLACE_ERROR_CASE, payload: res });
      dispatch(metaReducer.addToastr({ message: "Sag taget", type: "success" }));
    }
  };
}

export function releaseErrorCase(errorCase: IErrorCaseVm) {
  return async (dispatch: Dispatch<any>) => {
    let res: IErrorCaseVm | IErrorVm = null;
    res = await Api.errorCase.releaseErrorCase(errorCase.id);

    if (!!res.errorNumber) {
      dispatch({ type: REPLACE_ERROR_CASE, payload: res });
      dispatch(metaReducer.addToastr({ message: "Sag frigivet", type: "success" }));
    }
  };
}

export function resolveErrorCase(errorCase: IErrorCaseVm, selectedSolveStatus: ErrorCaseStatusType) {
  return async (dispatch: Dispatch<any>) => {
    let res: IErrorCaseVm | IErrorVm = null;
    // First, save comment before calling Resolve
    const saveCommentRes = await Api.errorCase.saveErrorCaseComment(errorCase);

    // Check if comment was saved successfully
    if (!!saveCommentRes && !!saveCommentRes.errorNumber) {
      res = await Api.errorCase.resolveErrorCase(errorCase.id, selectedSolveStatus);

      // Check if case was resolved successfully
      if (!!res.errorNumber) {
        dispatch({ type: REPLACE_ERROR_CASE, payload: res });
        dispatch(metaReducer.addToastr({ message: "Sag løst", type: "success" }));
      }
    }
  };
}

export function reopenErrorCase(errorCase: IErrorCaseVm) {
  return async (dispatch: Dispatch<any>) => {
    let res: IErrorCaseVm | IErrorVm = null;
    res = await Api.errorCase.reopenErrorCase(errorCase.id);

    if (!!res && !!res.errorNumber) {
      dispatch({ type: REPLACE_ERROR_CASE, payload: res });
      dispatch(metaReducer.addToastr({ message: "Sag genåbnet", type: "success" }));
    }
  };
}

export function saveErrorCaseComment(errorCase: IErrorCaseVm) {
  return async (dispatch: Dispatch<any>) => {
    let res: IErrorCaseVm | IErrorVm = null;
    res = await Api.errorCase.saveErrorCaseComment(errorCase);

    if (!!res && !!res.errorNumber) {
      dispatch({ type: REPLACE_ERROR_CASE, payload: res });
      dispatch(metaReducer.addToastr({ message: "Kommentar gemt", type: "success" }));
    }
  };
}

export function updateComment(value: string, errorCaseId: string) {
  return { type: UPDATE_COMMENT, payload: value, id: errorCaseId };
}

export function updateErrorCaseStatus(value: ErrorCaseStatusType, errorCaseId: string) {
  return { type: UPDATE_ERROR_CASE_STATUS, payload: value, id: errorCaseId };
}
